import { TerritoryVersionType } from '../../layouts/TerritoryPageLayout/TerritoryPageLayout';
import { TArticleCardProps } from '../ArticleCard/ArticleCard';
import { ArticlesSortingDropdownKey } from '../TerritoryArticlesSection/constants';
import { TColumnVariant } from '../TerritoryGridContainer/TerritoryGridContainer';

export const enum TerritoryCommunitySectionSelectedTab {
  members = 'members',
  membershipRoles = 'membership-roles',
}

export const TERRITORY_COMMUNITY_TAB_LIST = [
  { tab: TerritoryCommunitySectionSelectedTab.members, label: 'Members' },
  { tab: TerritoryCommunitySectionSelectedTab.membershipRoles, label: 'Membership Roles' },
];

export const TERRITORY_EXPLORE_POSTS_PAGE_SIZE = 6;
export const TERRITORY_POSTS_AND_PROMPTS_PAGE_SIZE = 16;

export type TTerritoryExploreAllSectionProps = {
  territoryId: string;
  authenticatedUserId?: string;
};

export type TTerritoryPostsContainerProps = {
  territoryId: string;
  sortBy?: ArticlesSortingDropdownKey;
  articles: TArticleCardProps[];
  hasMoreArticlesToLoad?: boolean;
  isCollapsedSection?: boolean;
  showLoadMoreButton?: boolean;
  onLoadMoreWithToggle?: () => void;
  isLoading?: boolean;
  isCalled?: boolean;
  canManagePinnedArticles?: boolean;
  isPinningEnabled?: boolean;
  sectionTitle: string;
  forceMobileView?: boolean;
  gridColumns?: TColumnVariant;
  hideSortingDropdown?: boolean;
  onSortByChange?: (sortBy: string) => void;
  isAuthLoading?: boolean;
  territorySlug?: string;
  territoryVersion?: TerritoryVersionType;
  hideSeeAllButton?: boolean;
  seeAllUrl?: string;
};
